import React from 'react';
import { Spin } from 'antd';

import { Container } from './styles';

interface LoadingProps {
  background?: string;
  minHeight?: string | number;
  maxHeight?: string | number;
}

const Loading: React.FC<LoadingProps> = props => {
  return (
    <Container
      background={props.background}
      style={{ minHeight: props.minHeight, maxHeight: props.maxHeight }}
    >
      <Spin size="large" />
    </Container>
  );
};

export default Loading;
